import React from 'react';
import { RadioGroup } from './shared';
import useAppSettings from '../../hooks/useAppSettings';

const OPTIONS = [
  { value: 'required', label: 'Required' },
  { value: 'optional', label: 'Optional' },
  { value: 'donot', label: 'Do not ask' },
];
const FIELDS = [
  { key: 'phone', label: 'Ask phone number' },
  { key: 'resume', label: 'Resume upload' },
  { key: 'linkedin', label: 'Ask LinkedIn URL' },
  { key: 'city', label: "Ask for candidate's city" },
];

function FieldCard({ field, value, onChange }) {
  return (
    <div className="rounded-xl border border-[#ECE6FA] bg-white p-4">
      <p className="text-[13.5px] font-semibold text-[#1A1533]">{field.label}</p>
      <div className="mt-3">
        <RadioGroup value={value} onChange={onChange} options={OPTIONS} />
      </div>
    </div>
  );
}

export default function ApplicationFormTab() {
  const { state, update } = useAppSettings();
  const form = state.application_form || {};
  const setField = (key) => (v) => update({ application_form: { ...form, [key]: v } });

  return (
    <div>
      <h2 className="text-[18px] font-bold text-[#1A1533]">Application form</h2>
      <p className="text-[13px] text-[#4A4463] mt-2 leading-relaxed">
        Manage the fields required in the AI interview application form. By default, these fields are mandatory, but you can toggle them off if not needed for your hiring process.
      </p>
      <div className="mt-5 space-y-4">
        {FIELDS.map((f) => (
          <FieldCard key={f.key} field={f} value={form[f.key] || 'required'} onChange={setField(f.key)} />
        ))}
      </div>
    </div>
  );
}
